import $ from 'jquery';

export default class ShippingCalculator {
  constructor(el) {
    this.el = el;

    try {
      this.data = JSON.parse($('[data-shipping-calculator-data]', el).text());
    } catch (e) {
      console.log('No shipping localisations found, unable to continue.');
    }

    if (!this.data) { return; }

    this.shippingCalculator();

    if (this.data.settings.customer_country) {
      this.calculateShipping();
    }

    $('[data-calculate-shipping-button]', this.el).on('click', () => this.calculateShipping());

    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  shippingCalculator() {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.data.language.submit_button,
      submitButtonDisabled: this.data.language.submit_button_processing,
      customerIsLoggedIn: this.data.settings.customer_country,
      moneyFormat: Theme.moneyFormat,
    });

    const selectableOptions = $('.cart-shipping-calculator select', this.el);

    setTimeout(() => {
      for (let i = 0; i < selectableOptions.length; i++) {
        this.updateShippingLabel(selectableOptions[i]);
      }
    }, 500);

    $('.cart-shipping-calculator select', this.el).change(() => {
      for (let i = 0; i < selectableOptions.length; i++) {
        this.updateShippingLabel(selectableOptions[i]);
      }
    });
  }

  calculateShipping() {
    $('[data-calculate-shipping-button]').val(this.data.language.submit_button_processing);

    const shippingAddress = {};
    shippingAddress.zip = $('.address-zip').val() || '';
    shippingAddress.country = $('.address-country').val() || '';
    shippingAddress.province = $('.address-province').val() || '';

    const queryString = Object.keys(shippingAddress)
    .map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`)
    .join('&');

    $.ajax(`${window.Theme.routes.cart_url}/shipping_rates.json?${queryString}`, { dataType: 'json' })
      .fail(error => this.handleErrors(error.responseJSON || {}))
      .done(response => {
        const rates = response.shipping_rates;
        let responseText;
        let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
        if (!shippingAddress.province.length) {
          address = `${shippingAddress.zip}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.zip.length) {
          address = `${shippingAddress.province}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.province.length || !shippingAddress.zip.length) {
          address = shippingAddress.country;
        }

        const shippingCalculatorResponse = $('.cart-shipping-calculator-response');
        shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");

        const ratesFeedback = $('.shipping-calculator-response');

        if (rates.length > 1) {
          const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);

          responseText = this.data.language.multi_rates
            .replace('** address **', address)
            .replace('** number_of_rates **', rates.length)
            .replace('** rate **', `<span class='money'>${firstRate}</span>`);

          ratesFeedback.html(responseText);
        } else if (rates.length === 1) {
          responseText = this.data.language.one_rate
            .replace('** address **', address);
          ratesFeedback.html(responseText);
        } else {
          ratesFeedback.html(this.data.language.no_rates);
        }

        for (let i = 0; i < rates.length; i++) {
          const rate = rates[i];
          const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
          const rateValues = this.data.language.rate_values
            .replace('** rate_title **', rate.name)
            .replace('** rate **', `<span class='money'>${price}</span>`);
          $('.shipping-rates', this.el).append(`<li>${rateValues}</li>`);
        }

        $('[data-calculate-shipping-button]').val(this.data.language.submit_button);
      });
  }

  updateShippingLabel(select) {
    if (select) {
      const $select = $(select);
      let selectedOption = $select.find('option:selected').val();

      if (!selectedOption) {
        selectedOption = $select.prev('.selected-text').data('default');
      }

      $select.prev('.selected-text').text(selectedOption);

      setTimeout(() => {
        if ($select.attr('name') === 'address[country]') {
          this.updateShippingLabel($('#address_province', this.el));
        }
      },
      500);
    }
  }

  handleErrors(errorMessage) {
    if (errorMessage.zip) {
      errorMessage = this.data.language.error_message.replace('** error_message **', errorMessage.zip);
    } else if (errorMessage.error) {
      errorMessage = this.data.language.generic_error_message.replace(
        '** error_message **',
        errorMessage.error.map(error => Object.keys(error).map(key => error[key]).join('\n')).join('\n'),
      );
    } else {
      return;
    }

    $('.cart-shipping-calculator-response').html(`<p>${errorMessage}</p>`);
  }

  onSectionUnload() {
    $('[data-calculate-shipping-button]', this.el).off('click');
  }

  unload() {
    $('[data-calculate-shipping-button]', this.el).off('click', () => this.calculateShipping());

    Shopify.onError = () => {};
  }
}
